export default defineNuxtPlugin(async () => {
  const { region } = useRuntimeConfig().public

  if (region) {
    const registrations = await navigator.serviceWorker?.getRegistrations() || []
    const regionServiceWorkerPath = `/${region}/sw.js`

    // Removes any lingering service workers from other regions on the same top-level domain.
    // E.g. if we visit vans.com/en-us first and get the /nora/sw.js worker,
    // and then navigate to vans.com/en-gb, we'd still see the /nora/sw.js worker
    // until pre-caching gets completed and the new /emea/sw.js worker get installed instead.
    // This way we avoid having the wrong cache from a different region in place while pre-caching is happening.
    registrations
      .filter(
        (registration) => {
          const scriptURL = registration.active?.scriptURL
          if (!scriptURL) {
            return false
          }
          return new URL(scriptURL).pathname !== regionServiceWorkerPath
        }
      )
      .forEach((registration) => {
        registration.unregister()
      })
  }
})
